var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm._l(_vm.alerts, function (alert, index) {
    return [_c('alerts-item', _vm._b({
      key: index
    }, 'alerts-item', {
      index,
      alert
    }, false))];
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }